import { AuthInitialState } from "../reducers/AuthReducer";
import { CommonInitialState } from "../reducers/commonReducer";

const AppDefaultReducer = {
  auth: AuthInitialState,
  common: CommonInitialState,
};

export default AppDefaultReducer;
